// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pat-card-container {
    width: 100%;
    padding: 1.5rem 1.75rem;
    background-color: var(--clr-white);
    border: 1px solid var(--clr-grey-8);
    border-radius: var(--radius);
    box-shadow: var(--shadow-1);
    transition: all 0.3s ease-in-out;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    position: relative;
  }
  
  .pat-card-container:hover {
    box-shadow: var(--shadow-3);
    transform: translateY(-2px);
    border-color: var(--clr-primary-5);
  }
  
  .pat-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    border-bottom: 1px solid var(--clr-grey-7);
    padding-bottom: 0.75rem;
    gap: 1rem;
  }
  
  .pat-card-date-time {
    display: flex;
    flex-direction: column;
    font-size: 0.95rem;
    color: var(--clr-grey-4);
  }
  
  .pat-card-date-time h4 {
    font-size: 1.25rem;
    margin: 0;
    font-weight: 600;
    color: var(--clr-grey-1);
  }
  
  .pat-card-time {
    font-size: 1rem;
    font-weight: 500;
    color: var(--clr-grey-1);
    margin-top: 0.25rem;
    /* background-color: var(--clr-primary-8); */
    padding: 0.25rem 0.5rem;
    border-radius: 6px;
    display: inline-block;
    width: fit-content;
  }
  
  .pat-card-meta-box {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    text-align: right;
  }
  
  .pat-card-practitioner {
    font-size: 1.1rem;
    font-weight: 500;
    color: var(--clr-grey-2);
    margin-bottom: 0.4rem;
  }
  
  .pat-card-status {
    font-size: 0.75rem;
    font-weight: 600;
    padding: 0.35rem 0.65rem;
    border-radius: var(--radius);
    display: inline-block;
    text-align: center;
    min-width: 140px;
    background-color: var(--clr-primary-10);
    border: 1px solid var(--clr-primary-6);
    color: var(--clr-primary-6);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }
  
  .pat-card-expand-icon {
    font-size: 1.3rem;
    font-weight: bold;
    color: var(--clr-primary-6);
    cursor: pointer;
    transition: transform 0.2s ease-in-out;
  }
  
  .pat-card-expand-icon:hover {
    transform: scale(1.2);
  }
  
  /* Responsive */
  @media (max-width: 768px) {
    .pat-card-header {
      flex-direction: column;
      align-items: flex-start;
    }
  
    .pat-card-meta-box {
      align-items: flex-start;
      text-align: left;
    }
  }
  
  /* Responsive Styles */

@media (max-width: 768px) {
    .pat-card-container {
      padding: 1.25rem 1rem;
      gap: 0.75rem;
    }
  
    .pat-card-date-time h4 {
      font-size: 1.1rem;
    }
  
    .pat-card-time {
      font-size: 0.95rem;
      padding: 0.2rem 0.4rem;
    }
  
    .pat-card-practitioner {
      font-size: 1rem;
      margin-bottom: 0.3rem;
    }
  
    .pat-card-status {
      min-width: 120px;
      font-size: 0.7rem;
      padding: 0.3rem 0.5rem;
    }
  
    .pat-card-expand-icon {
      font-size: 1.15rem;
    }
  }
  
  @media (max-width: 480px) {
    .pat-card-date-time h4 {
      font-size: 1rem;
    }
  
    .pat-card-time {
      font-size: 0.9rem;
    }
  
    .pat-card-status {
      font-size: 0.68rem;
      min-width: unset;
      width: auto;
    }
  
    .pat-card-practitioner {
      font-size: 0.95rem;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/PatientTimeline/AppointmentCard.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,uBAAuB;IACvB,kCAAkC;IAClC,mCAAmC;IACnC,4BAA4B;IAC5B,2BAA2B;IAC3B,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;IAC3B,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,0CAA0C;IAC1C,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;IACnB,4CAA4C;IAC5C,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,4BAA4B;IAC5B,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,uCAAuC;IACvC,sCAAsC;IACtC,2BAA2B;IAC3B,yCAAyC;EAC3C;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,2BAA2B;IAC3B,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,qBAAqB;EACvB;;EAEA,eAAe;EACf;IACE;MACE,sBAAsB;MACtB,uBAAuB;IACzB;;IAEA;MACE,uBAAuB;MACvB,gBAAgB;IAClB;EACF;;EAEA,sBAAsB;;AAExB;IACI;MACE,qBAAqB;MACrB,YAAY;IACd;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,sBAAsB;IACxB;;IAEA;MACE,eAAe;MACf,qBAAqB;IACvB;;IAEA;MACE,gBAAgB;MAChB,iBAAiB;MACjB,sBAAsB;IACxB;;IAEA;MACE,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,gBAAgB;MAChB,WAAW;IACb;;IAEA;MACE,kBAAkB;IACpB;EACF","sourcesContent":[".pat-card-container {\n    width: 100%;\n    padding: 1.5rem 1.75rem;\n    background-color: var(--clr-white);\n    border: 1px solid var(--clr-grey-8);\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-1);\n    transition: all 0.3s ease-in-out;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    position: relative;\n  }\n  \n  .pat-card-container:hover {\n    box-shadow: var(--shadow-3);\n    transform: translateY(-2px);\n    border-color: var(--clr-primary-5);\n  }\n  \n  .pat-card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    border-bottom: 1px solid var(--clr-grey-7);\n    padding-bottom: 0.75rem;\n    gap: 1rem;\n  }\n  \n  .pat-card-date-time {\n    display: flex;\n    flex-direction: column;\n    font-size: 0.95rem;\n    color: var(--clr-grey-4);\n  }\n  \n  .pat-card-date-time h4 {\n    font-size: 1.25rem;\n    margin: 0;\n    font-weight: 600;\n    color: var(--clr-grey-1);\n  }\n  \n  .pat-card-time {\n    font-size: 1rem;\n    font-weight: 500;\n    color: var(--clr-grey-1);\n    margin-top: 0.25rem;\n    /* background-color: var(--clr-primary-8); */\n    padding: 0.25rem 0.5rem;\n    border-radius: 6px;\n    display: inline-block;\n    width: fit-content;\n  }\n  \n  .pat-card-meta-box {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    text-align: right;\n  }\n  \n  .pat-card-practitioner {\n    font-size: 1.1rem;\n    font-weight: 500;\n    color: var(--clr-grey-2);\n    margin-bottom: 0.4rem;\n  }\n  \n  .pat-card-status {\n    font-size: 0.75rem;\n    font-weight: 600;\n    padding: 0.35rem 0.65rem;\n    border-radius: var(--radius);\n    display: inline-block;\n    text-align: center;\n    min-width: 140px;\n    background-color: var(--clr-primary-10);\n    border: 1px solid var(--clr-primary-6);\n    color: var(--clr-primary-6);\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  }\n  \n  .pat-card-expand-icon {\n    font-size: 1.3rem;\n    font-weight: bold;\n    color: var(--clr-primary-6);\n    cursor: pointer;\n    transition: transform 0.2s ease-in-out;\n  }\n  \n  .pat-card-expand-icon:hover {\n    transform: scale(1.2);\n  }\n  \n  /* Responsive */\n  @media (max-width: 768px) {\n    .pat-card-header {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n  \n    .pat-card-meta-box {\n      align-items: flex-start;\n      text-align: left;\n    }\n  }\n  \n  /* Responsive Styles */\n\n@media (max-width: 768px) {\n    .pat-card-container {\n      padding: 1.25rem 1rem;\n      gap: 0.75rem;\n    }\n  \n    .pat-card-date-time h4 {\n      font-size: 1.1rem;\n    }\n  \n    .pat-card-time {\n      font-size: 0.95rem;\n      padding: 0.2rem 0.4rem;\n    }\n  \n    .pat-card-practitioner {\n      font-size: 1rem;\n      margin-bottom: 0.3rem;\n    }\n  \n    .pat-card-status {\n      min-width: 120px;\n      font-size: 0.7rem;\n      padding: 0.3rem 0.5rem;\n    }\n  \n    .pat-card-expand-icon {\n      font-size: 1.15rem;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .pat-card-date-time h4 {\n      font-size: 1rem;\n    }\n  \n    .pat-card-time {\n      font-size: 0.9rem;\n    }\n  \n    .pat-card-status {\n      font-size: 0.68rem;\n      min-width: unset;\n      width: auto;\n    }\n  \n    .pat-card-practitioner {\n      font-size: 0.95rem;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
